module.exports = "/_next/static/images/707b6592fa0a8d0a0333a79844b56f07-2-woman-working@0.75x.jpg.webp";